import styled from 'styled-components';
import colors from '../../../config/colors.json';

export const TableHeader = styled.div`
    font-size: 12px;
    line-height: 18px;
    color: ${colors.lightGrey10a};
    text-transform: uppercase;
`;

export const TableCell = styled.div`
    font-size: 14px;
    line-height: 21px;
    color: ${colors.darkGrey};
    text-transform: capitalize;
`;
